import {
  LayoutDashboard,
  List,
  Users,
  Calendar,
  ClipboardList,
  Inbox,
  Settings,
  Shield,
} from 'lucide-react'

// サイドバーとスマホ上部バー（いまの画面名）で共有する。
export const navItems = [
  { to: '/', icon: LayoutDashboard, labelKey: 'nav.dashboard' },
  { to: '/camps', icon: List, labelKey: 'nav.camps' },
  { to: '/partners', icon: Users, labelKey: 'nav.partners' },
  { to: '/timeline', icon: Calendar, labelKey: 'nav.timeline' },
  { to: '/inquiries', icon: Inbox, labelKey: 'nav.inquiries' },
  { to: '/forms', icon: ClipboardList, labelKey: 'nav.forms' },
  { to: '/settings', icon: Settings, labelKey: 'nav.settings' },
  { to: '/admin', icon: Shield, labelKey: 'nav.admin' },
]
